import { render, staticRenderFns } from "./TablePaginatedOrdersBase.vue?vue&type=template&id=c5d3b08c&scoped=true"
import script from "./TablePaginatedOrdersBase.vue?vue&type=script&lang=js"
export * from "./TablePaginatedOrdersBase.vue?vue&type=script&lang=js"
import style0 from "./TablePaginatedOrdersBase.vue?vue&type=style&index=0&id=c5d3b08c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d3b08c",
  null
  
)

export default component.exports